import { useMemo } from 'react'
import classNames from 'classnames'

import ConfigurableSections from '../../../../components/ConfigurableSections'
import useConditionalData from '../../../../hooks/useConditionalData'
import { createEventSectionsConfig } from './config/sectionsConfig'

import styles from './styles.module.scss'

const EventBody = ({ event }) => {
  const conditions = useConditionalData(event, {
    hasDescription: 'description',
    hasGrade: 'grade',
    hasCountries: 'countries',
    hasGames: data => !!data?.games?.games?.length,
    hasOrganizerLogo: 'organizerLogo',
    hasTeamOfOrganizer: 'teamOfOrganizer',
    hasContacts: 'contacts',
    hasPartnerLogo: 'partnerLogo',
    hasSponsorLogo: 'sponsorLogo',
    hasAnyPhotos: 'anyPhotos',
  })

  const sectionsConfig = useMemo(
    () => createEventSectionsConfig(event, conditions, styles),
    [event, conditions]
  )

  const sectionClassName = useMemo(
    () => classNames(styles.news, styles.eventBodyBg),
    []
  )

  return (
    <div className={styles.top}>
      <ConfigurableSections
        data={event}
        conditions={conditions}
        sections={sectionsConfig}
        className={sectionClassName}
      />
    </div>
  )
}

export default EventBody
